import { SPECIMEN_BAG_SCAN } from "app/constants";
import { BarcodeObject } from "util/objectFromBarcode";

export const setSpecimenBag = (barcode?: BarcodeObject) => {
  return {
    type: SPECIMEN_BAG_SCAN,
    payload: barcode,
  };
};
